export function isFunction(value): boolean {
    return typeof value === 'function';
}
